import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { ENUMS } from '../../../../../utils/constants';
import { onValueChange, validateInputsRequired } from '../../../../../utils/handleChangeHooks';
import { enumText, translate, isNullOrEmpty, handleFormKeyDown } from '../../../../../utils/util';
import InventoryService from '../../../../../services/InventoryService';
import { ConfirmModal, Button, SelectItem, Input, ScannerCode, Card, Breadcrumbs } from '../../../../../components/UI/ComponentsUI';

const UserLotGeneral = (props) => {
    const [userName, setUserName] = useState('');
    const [model, setModel] = useState({
        initialLot: undefined,
        finalLot: undefined,
        lotOriginId: ENUMS.eInventoryOriginCount.Mobile.value.toString(),
    });

    useEffect(() => {
        const inputusername = document.getElementById('username');
        if (inputusername) {
            inputusername.focus();
        }
        M.updateTextFields();
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const submit = () => {
        if (validateInputsRequired("userLotGeneral")) {
            const modal = M.Modal.init(document.getElementById('confirmChangeUser'));
            modal.open();
        }
    }

    const confirm = () => {
        model.userName = userName;
        props.changeUserLots(model, props.inventory.id, () => {
            props.history.goBack();
        });
    }

    const scanner = (value) => {
        if (!isNullOrEmpty(value)) {
            onChangeSelectItem(value);
            const inputusername = document.getElementById('userName');
            if (inputusername) {
                inputusername.value = value;
                inputusername.focus();
            }
            M.updateTextFields();
        }
    };

    const onChangeSelectItem = (event) => {
        setUserName(event);
    };

    return (
        <div>
            <Breadcrumbs id="receiptParameters" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('inventory', 'inventory') }}
                subtitles={[{ icon: "mdi mdi-clipboard-list-outline", label: translate('general.menu.lotUser', 'inventory') }]} />
            <div className="container" style={{ marginTop: '40px', }}>
                <Card>
                    <form id="userLotGeneral" onKeyDown={(e) => handleFormKeyDown(e, submit)}>
                        <div className="row" style={{ marginBottom: '0' }}>
                            <div className="input-field no-padding col s12">
                                <span className="field f-1p5r">{props.inventory.code}</span>
                                <label className="active" htmlFor="productId">{translate('partNumberCode', 'inventory')}</label>
                            </div>
                            <div className="input-field no-padding col s12">
                                <span className="field f-1r truncate">{props.inventory.name}</span>
                                <label className="active" htmlFor="pn">{translate('partNumberDescription', 'inventory')}</label>
                            </div>
                            <div className="input-field no-padding col s12">
                                <span className="field f-1r truncate">{translate(enumText(ENUMS.eInventoryStatus, props.inventory.status), 'inventory')}</span>
                                <label className="active" htmlFor="status">{translate('status', 'inventory')}</label>
                            </div>
                            <div className="input-field no-padding col s12">
                                <ScannerCode className="mdi mdi-qrcode posfix" onScanner={scanner} />
                                <SelectItem
                                    required
                                    label={translate('login.username')}
                                    id="userName"
                                    name="userName"
                                    value={userName}
                                    onChange={(event) => onChangeSelectItem(event)}
                                    onChangeData={onChangeSelectItem}
                                    data={props.usersFromElog ? props.usersFromElog.map(item => {
                                        return {
                                            id: item.id,
                                            text: item.user
                                        }
                                    }) : []}
                                />
                            </div>
                            <div className="input-field no-padding col s6">
                                <Input
                                    required
                                    id="initialLot"
                                    name="initialLot"
                                    label={translate('inicial-lot', 'inventory')}
                                    type="number"
                                    onChange={onChange}
                                    defaultValue={model.initialLot} />
                            </div>
                            <div className="input-field no-padding col s5">
                                <Input
                                    required
                                    id="finalLot"
                                    name="finalLot"
                                    label={translate('final-lot', 'inventory')}
                                    type="number"
                                    onChange={onChange}
                                    defaultValue={model.finalLot} />
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: '10px' }}>
                            <div className="col s6">
                                <Button full="true" onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            </div>
                            <div className="col s6">
                                <Button full="true" onClick={() => submit()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </form>
                </Card>
            </div>
            <ConfirmModal
                id="confirmChangeUser"
                data={{ title: translate('attention', 'validations'), message: translate('confirm-assignment-lot', 'inventory') }}
                onConfirm={confirm}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
}

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        inventory: state.inventoryReducer.inventory,
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeUserLots: (model, inventoryId, callback) => {
            dispatch(InventoryService.changeUserLots(model.userName, model.initialLot, model.finalLot, model.lotOriginId, inventoryId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UserLotGeneral)));
